'use strict';

angular.module('app.entity.field.audit').controller('GridRowAuditController', [
    'CrfService',
    'ShareCrfSDK',
    '$stateParams',
    'RecordDataService',
    'CrdConfigurationService',
    'Event',
    function(CrfService, ShareCrfSDK, $stateParams, RecordDataService, CrdConfigurationService, Event) {
        var vm = this;

        // Instancia del grid
        var gridInstance;

        // Las instancias de campo que pertenecen a la fila del grid
        var rowFields = [];

        // Lista de UIDs como string -para facilitar las comparaciones- de los campos calculados arriba
        var rowUids = [];

        // Filas de audit relativas a los campos del grid
        vm.audit = [];

        // Estado de carga del audit de la fila
        vm.loaded = false;

        // Si se debe mostrar la razón del cambio de valor
        vm.showReason = CrdConfigurationService.getAudit().hasReason();

        // Handler de evento de recarga del cuaderno, para recalcular el audit en ese momento
        var recordLoadedHandler = null;

        vm.$onInit = function() {
            gridInstance = CrfService.getField(vm.gridId);

            rowFields = gridInstance.getCells()[vm.rowIndex].filter(function(cell) {
                return cell !== null;
            });

            var listIndices = CrfService.getListIndices($stateParams);
            rowUids = rowFields.map(function(field) {
                return RecordDataService.getElementUID(field.getId(), listIndices).join('.');
            });

            reload();

            recordLoadedHandler = Event.on('recordLoaded', reload);
        };

        vm.$onDestroy = function() {
            if (angular.isFunction(recordLoadedHandler)) {
                recordLoadedHandler();
            }
        };

        function reload() {
            vm.loaded = false;

            ShareCrfSDK.ecrd.getRecordAuditLog($stateParams.recordId)
                .then(function(audit) {
                    vm.audit = audit.reduce(function(acc, item) {
                        var changesList  = item.change.reduce(function(itemAcc, change) {
                            if (angular.isArray(change.uid)) {
                                // Conociendo la posición podemos saber a qué campo se refiere
                                var uidPosition = rowUids.indexOf(change.uid.join('.'));
                                if (uidPosition > -1) {
                                    var changeCopy = angular.copy(change);
                                    var field = rowFields[uidPosition];

                                    // ¿Hará falta esto o puede venir de la API ya con la propiedad?
                                    // @see FieldAuditController
                                    if (field.getFormControl() === 'files') {
                                        changeCopy.format = 'fieldfiles';
                                    } else if (field.getFormControl() === 'dicom') {
                                        changeCopy.format = 'dicom';
                                    }

                                    changeCopy.column = field.getGridColumnName();

                                    itemAcc.push(changeCopy);
                                }
                            }

                            return itemAcc;
                        }, []);

                        // quitamos finalmente las líneas de audit que no contengan ningún cambio relacionado
                        if (changesList.length > 0) {
                            var itemCopy = angular.copy(item);
                            itemCopy.change = changesList;
                            acc.push(itemCopy);
                        }

                        return acc;
                    }, []);

                    vm.loaded = true;
                });
        }
    },
]);
